import { render, staticRenderFns } from "./SideBarLayout.vue?vue&type=template&id=6db6d028&scoped=true&"
import script from "./SideBarLayout.vue?vue&type=script&lang=ts&"
export * from "./SideBarLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarLayout.vue?vue&type=style&index=0&id=6db6d028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db6d028",
  null
  
)

export default component.exports